<template>
    <div>
        <div class="flex flex-row align-items-start justify-content-between">
            <div class="flex flex-row align-items-start justify-content-center">
                <Button @click="baixarRelatorio" class="mb-5" label="Download Relatório" icon="pi pi-file-pdf" />

                <BtnVisualizarPDF></BtnVisualizarPDF>
            </div>

            <div class="flex flex-row align-items-start justify-content-center">
                <Button label="Redefinir Informações" icon="pi pi-times-circle" class="p-button-secondary" @click="confirmarSalvar('R')" />

                <Button label="Salvar Posições" icon="pi pi-check-circle" class="ml-2 p-button-primary" @click="confirmarSalvar('S')" />
            </div>
        </div>

        <div class="p-fluid formgrid grid">
            <div class="field col-12" v-for="texto in textosPadraoTemplate" :key="texto.posicao">
                <label>Posição {{ texto.posicao }}:</label>
                <Textarea v-model="texto.conteudo" :onkeyup="() => armazenarAlteracoesTemplates()" rows="5" />
            </div>
        </div>
    </div>
</template>

<script>
import TextosPadraoTemplate from './TextosPadraoTemplate.json';
import BtnVisualizarPDF from './BtnVisualizarPDF.vue';
import Services from './services';

export default {
    components: {
        BtnVisualizarPDF,
    },

    props: {
        convenio: {
            type: Object,
        },
    },

    data() {
        return {
            textosPadraoTemplate: [],
            textosPadraoTemplateBase: [],
            textosPadraoAlterados: [],
            textosPadraoAlteradosTemplateBase: [],
        };
    },

    methods: {
        baixarRelatorio() {
            this.$store.dispatch('addRequest');
            Services.baixarRelatorioPrestacaoContas(this.$route.params.id, this.convenio?.cpfCnpj)
                .then((response) => {
                    if (response?.success) {
                        this.$download(response.data, `PrestacaoContasRelatorio.pdf`);
                    }
                })
                .finally(() => this.$store.dispatch('removeRequest'));
        },

        confirmarSalvar(operacao) {
            this.$confirm.require({
                message: `Tem certeza que deseja ${operacao == 'S' ? 'salvar' : 'resetar'} os dados do template`,
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.salvar(operacao);
                },
            });
        },

        salvar(operacao) {
            if (operacao == 'S') this.atualizarDadosTemplate();
            else this.resetarValores();
        },

        atualizarDadosTemplate() {
            if (this.textosPadraoAlterados.length <= 0) return;
            const camposNaoPreenchidos = this.textosPadraoAlterados.filter((textoAlterado) => textoAlterado.conteudo?.length <= 0);

            if (camposNaoPreenchidos.length > 0) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Prestação de Contas',
                    detail: `Todos os campos referentes a posição no relatório de prestação de contas são obrigatórios. As posições ${camposNaoPreenchidos.map(
                        (campo) => `${campo?.posicao}, `
                    )}.`,
                    life: 3000,
                });

                return;
            }

            this.$store.dispatch('addRequest');
            Services.salvarTodasAlteracoesTemplateBasePorConvenio(this.$route.params.id, this.textosPadraoAlterados)
                .then((response) => {
                    if (response?.success) {
                        this.tratarConteudoTemplate();
                    }
                })
                .finally(() => this.$store.dispatch('removeRequest'));
        },

        resetarValores() {
            this.$store.dispatch('addRequest');
            Services.resetarTodasAlteracoesTemplateBasePorConvenio(this.$route.params.id)
                .then((response) => {
                    if (response?.success) {
                        this.tratarConteudoTemplate();
                    }
                })
                .finally(() => this.$store.dispatch('removeRequest'));
        },

        armazenarAlteracoesTemplates() {
            this.textosPadraoTemplateBase.forEach((textoPadraoBase) => {
                const textoPadraoDiferente = this.textosPadraoTemplate.find(
                    (textoPadrao) =>
                        textoPadrao.posicao == textoPadraoBase.posicao &&
                        textoPadrao.conteudo != textoPadraoBase.conteudo &&
                        (this.textosPadraoAlteradosTemplateBase.filter(
                            (textoPadraoAlteradoBase) =>
                                textoPadraoAlteradoBase?.posicao == textoPadrao.posicao && textoPadraoAlteradoBase?.conteudo != textoPadrao.conteudo
                        ).length > 0 ||
                            this.textosPadraoAlteradosTemplateBase.filter((textoPadraoAlteradoBase) => textoPadraoAlteradoBase?.posicao == textoPadrao.posicao)
                                .length <= 0)
                );

                if (textoPadraoDiferente) {
                    this.textosPadraoAlterados = this.textosPadraoAlterados.filter(
                        (textoPadraoAlterado) => textoPadraoAlterado?.posicao != textoPadraoDiferente?.posicao
                    );

                    this.textosPadraoAlterados.push({ ...textoPadraoDiferente, igualTemplateBase: false });
                    return;
                }

                const jaFoiAlteradoEVoltouAoPadrao = this.textosPadraoAlteradosTemplateBase.find(
                    (textoPadraoAlteradoBase) =>
                        textoPadraoAlteradoBase.posicao == textoPadraoBase.posicao &&
                        this.textosPadraoTemplate.filter(
                            (textoPadrao) =>
                                textoPadrao?.conteudo != textoPadraoAlteradoBase.conteudo && textoPadrao?.posicao == textoPadraoAlteradoBase?.posicao
                        ).length > 0
                );

                if (jaFoiAlteradoEVoltouAoPadrao) {
                    this.textosPadraoAlterados = this.textosPadraoAlterados.filter(
                        (textoPadraoAlterado) => textoPadraoAlterado?.posicao != jaFoiAlteradoEVoltouAoPadrao?.posicao
                    );

                    this.textosPadraoAlterados.push({ ...textoPadraoBase, igualTemplateBase: true });
                    return;
                }

                this.textosPadraoAlterados = this.textosPadraoAlterados.filter(
                    (textoPadraoAlterado) => textoPadraoAlterado?.posicao != textoPadraoBase?.posicao
                );
            });
        },

        tratarConteudoTemplate() {
            this.textosPadraoTemplate = [];
            this.textosPadraoTemplateBase = [];

            TextosPadraoTemplate.forEach((textoPadrao) => {
                this.textosPadraoTemplate.push({ ...textoPadrao, idCnt: this.$route.params.id });
                this.textosPadraoTemplateBase.push({ ...textoPadrao, idCnt: this.$route.params.id });
            });

            this.obterAlteracoesTemplateBase();
        },

        tratarConteudoAlteradoTrazidoDaApi() {
            this.textosPadraoTemplateBase.forEach((textoPadraoTemplateBase) => {
                const textoDiferenteParaExibir = this.textosPadraoAlteradosTemplateBase.find((texto) => texto.posicao == textoPadraoTemplateBase.posicao);

                if (textoDiferenteParaExibir) {
                    this.textosPadraoTemplate = this.textosPadraoTemplate.filter((textoPadrao) => textoPadrao.posicao !== textoDiferenteParaExibir.posicao);

                    this.textosPadraoTemplate.push({ ...textoDiferenteParaExibir });
                    this.textosPadraoTemplate.sort((a, b) => a.posicao - b.posicao);
                }
            });
        },

        obterAlteracoesTemplateBase() {
            this.$store.dispatch('addRequest');
            Services.obterTodasAlteracoesTemplateBasePorConvenio(this.$route.params.id)
                .then((response) => {
                    if (response?.success) {
                        this.textosPadraoAlteradosTemplateBase = [...response.data];
                        this.tratarConteudoAlteradoTrazidoDaApi();
                    }
                })
                .finally(() => this.$store.dispatch('removeRequest'));
        },
    },

    mounted() {
        this.tratarConteudoTemplate();
    },
};
</script>
